import { Link } from "react-router-dom";
import { FaUserFriends, FaExpandArrowsAlt, FaBed, FaArrowRight } from "react-icons/fa";
import "../styles/RoomCard.css";

const RoomCard = ({ room }) => (
  <article className="room-card">
    <div className="room-img">
      <img src={room.image} alt={room.name} loading="lazy" />
      <span className="room-price">{room.price}<small> / night</small></span>
    </div>

    <div className="room-body">
      <h3>{room.name}</h3>

      <div className="room-meta">
        <span><FaUserFriends /> {room.capacity}</span>
        <span><FaExpandArrowsAlt /> {room.size}</span>
        <span><FaBed /> {room.bed}</span>
      </div>

      <p>{room.short}</p>

      <div className="room-features">
        {room.features.map((f) => <span key={f}>{f}</span>)}
      </div>

      <div className="room-actions">
        <a href="#booking" className="btn btn-primary">Book Now</a>
        <Link to="/rooms" className="room-link">View Details <FaArrowRight /></Link>
      </div>
    </div>
  </article>
);

export default RoomCard;